export const RGPD = {
  RGPD_MAIN_DESCRIPTION: 'COMMON_RGPD_MAIN_DESCRIPTION',
  RGPD_MAIN_MORE_TEXT: 'COMMON_RGPD_MAIN_MORE_TEXT',
  RGPD_MAIN_MORE_LINK: 'COMMON_RGPD_MAIN_MORE_LINK',
  RGPD_MAIN_SHOW_SETTINGS: 'COMMON_RGPD_MAIN_SHOW_SETTINGS',
  RGPD_MAIN_NO_ALL: 'COMMON_RGPD_MAIN_NO_ALL',
  RGPD_MAIN_YES_ALL: 'COMMON_RGPD_MAIN_YES_ALL',
  RGPD_SETTINGS_TITLE: 'COMMON_RGPD_SETTINGS_TITLE',
  RGPD_SETTINGS_OPERATION_COOKIES: 'COMMON_RGPD_SETTINGS_OPERATION_COOKIES',
  RGPD_SETTINGS_GOOGLE_COOKIES: 'COMMON_RGPD_SETTINGS_GOOGLE_COOKIES',
  RGPD_SETTINGS_MANDATORY: 'COMMON_RGPD_SETTINGS_MANDATORY',
  RGPD_SETTINGS_SAVE: 'COMMON_RGPD_SETTINGS_SAVE',
  RGPD_SETTINGS_BACK: 'COMMON_RGPD_SETTINGS_BACK',
};
